import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { ArrowRight, CheckCircle, Users, Target, Mic, TrendingUp, Award, BookOpen, MessageSquare, Calendar, Search, ClipboardList, Rocket, Repeat, MapPin, HelpCircle } from "lucide-react";
import { Helmet } from "react-helmet-async";
import { useCountUp } from "@/hooks/useCountUp";
import { Link } from "react-router-dom";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import SEOHead from "@/components/seo/SEOHead";
import mentoria1 from "@/assets/mentoria-1.jpg";
import mentoria2 from "@/assets/mentoria-2.jpg";
import mentoria3 from "@/assets/mentoria-3.jpg";
import mentoria4 from "@/assets/mentoria-4.jpg";
import mentoria5 from "@/assets/mentoria-5.jpg";
import mentoria6 from "@/assets/mentoria-6.jpg";
import juniorBianchim from "@/assets/junior-bianchim.jpg";
const StatsSection = () => {
  const anos = useCountUp(20, 1800);
  const profissionais = useCountUp(1000, 2000);
  const satisfeitos = useCountUp(99, 1600);
  const empresas = useCountUp(100, 1800);

  return (
    <section className="py-12 bg-muted/20" aria-label="Estatísticas">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
          <div ref={anos.ref}>
            <p className="text-4xl font-bold text-primary">{anos.count}+</p>
            <p className="text-sm text-muted-foreground mt-1">Anos de Experiência</p>
          </div>
          <div ref={profissionais.ref}>
            <p className="text-4xl font-bold text-primary">{profissionais.count}+</p>
            <p className="text-sm text-muted-foreground mt-1">Profissionais Treinados</p>
          </div>
          <div ref={satisfeitos.ref}>
            <p className="text-4xl font-bold text-primary">{satisfeitos.count}%</p>
            <p className="text-sm text-muted-foreground mt-1">Clientes Satisfeitos</p>
          </div>
          <div ref={empresas.ref}>
            <p className="text-4xl font-bold text-primary">{empresas.count}+</p>
            <p className="text-sm text-muted-foreground mt-1">Empresas Atendidas</p>
          </div>
        </div>
      </div>
    </section>
  );
};

const Consultoria = () => {
  const servicos = [{
    numero: "01",
    icon: Target,
    title: "Estruturação Comercial",
    description: "Realizamos uma análise completa da sua estrutura comercial atual, identificando pontos de melhoria e implementando processos eficientes de vendas. O nosso objetivo é garantir um monitoramento contínuo para que sua equipe atinja resultados consistentes e cresça de forma escalável.",
    features: ["Análise do funil de vendas atual", "Mapeamento de processos comerciais", "Identificação de gaps de performance", "Monitoramento contínuo de resultados"]
  }, {
    numero: "02",
    icon: BookOpen,
    title: "Treinamentos In Company",
    description: "Oferecemos treinamentos dinâmicos e práticos, voltados para as necessidades da sua equipe. As abordagens incluem técnicas de prospecção, negociação e fechamento, com aplicação imediata no dia a dia comercial. Isso resulta em melhora significativa nas habilidades de vendas.",
    features: ["Técnicas de prospecção ativa e passiva", "Metodologias de negociação (SPIN, BANT)", "Técnicas de fechamento avançadas", "Aplicação imediata no dia a dia"]
  }, {
    numero: "03",
    icon: Mic,
    title: "Palestras Corporativas",
    description: "Nossas palestras são conduzidas por especialistas e abordam temas cruciais como vendas, liderança e foco em resultados. Elas são projetadas para motivar a equipe e proporcionar insights práticos que impactam diretamente na performance e na cultura comercial da sua empresa.",
    features: ["Inteligência Emocional nas Vendas", "Liderança de Alta Performance", "Foco em Resultados", "Customização para seu evento"]
  }, {
    numero: "04",
    icon: TrendingUp,
    title: "Programas de Desenvolvimento Comercial",
    description: "Implantamos programas estruturados para impulsionar a performance comercial da sua equipe. Divididos em módulos, os programas focam em inteligência emocional, funil de vendas e negociação, garantindo que todos os participantes desenvolvam habilidades estratégicas para alcançar resultados sólidos.",
    features: ["Módulos progressivos e estruturados", "Inteligência emocional aplicada", "Desenvolvimento de funil de vendas", "Habilidades estratégicas de negociação"]
  }];
  const programaModulos = [{
    numero: 1,
    titulo: "Inteligência Emocional, Prospecção e Qualificação",
    topicos: ["Autoconhecimento e gestão emocional", "Técnicas de prospecção ativa e passiva", "Qualificação de leads (BANT, GPCT)"]
  }, {
    numero: 2,
    titulo: "Funil de Vendas, Follow-up e Abordagem Consultiva",
    topicos: ["Estruturação do funil de vendas", "Cadências de follow-up eficientes", "Vendas consultivas e SPIN Selling"]
  }, {
    numero: 3,
    titulo: "Apresentação de Propostas, Negociação e Fechamento",
    topicos: ["Construção de propostas de valor", "Técnicas de negociação win-win", "7 técnicas de fechamento"]
  }];
  const depoimentos = [{
    name: "Silvete Araujo",
    role: "Diretora de Negócios",
    company: "Zentai Benefícios",
    text: "Uma experiência extremamente enriquecedora, que trouxe novas perspectivas sobre o uso da inteligência artificial em negociações e estratégias comerciais. Um treinamento de alto nível, que transforma a forma como conduzimos negócios e fortalecemos relacionamentos."
  }, {
    name: "Giovanna Amaro Gireli",
    role: "Coordenadora de Marketing e Desenvolvimento Técnico",
    company: "Citróleo Group",
    text: "O treinamento com o Junior foi uma experiência extremamente valiosa. De forma dinâmica, ele trouxe insights poderosos para o time e também no nível pessoal, contribuindo diretamente para nossa evolução profissional e para o desenvolvimento da carreira."
  }, {
    name: "Marivaldo Souza",
    role: "CEO",
    company: "Triplos Tecnologia",
    text: "O treinamento proporcionou diversos insights e aprendizados valiosos. Compreendemos que todos têm um papel importante nas vendas. Tenho plena confiança de que nossa equipe vai evoluir e aproveitar cada oportunidade com mais estratégia e confiança."
  }, {
    name: "Shara Cartaxo",
    role: "Coordenadora de Vendas",
    company: "Latina Eletrodomésticos",
    text: "Buscava aprimorar minhas habilidades em negociação e encontrei exatamente o que precisava. O curso me ensinou a entender o cliente, criar propostas personalizadas e fechar com mais eficácia. Hoje fecho negócios com muito mais segurança."
  }, {
    name: "Joice Aparecida de Oliveira",
    role: "Assessora Comercial",
    company: "Mapfre Seguros",
    text: "Minha experiência no curso de Vendas em Alta Performance foi transformadora! Enfrentava muitos desafios no início da minha jornada no setor de seguros, e o curso me deu as técnicas e a segurança que eu precisava. Eu consegui realizar 4 vendas de um produto que ninguém conseguiu vender na empresa, graças as técnicas e estrategias que aprendi no treinamento."
  }, {
    name: "Cibele Maciel",
    role: "Vendedora",
    company: "",
    text: "Júnior, seu treinamento quebrou tabus que carrego há mais de 20 anos em vendas! Foi direto, prático e profundo. Já estou aplicando o que aprendi e voando em resultados. Nota 1000, meu mestre! Gratidão!"
  }, {
    name: "Gabriele Aparecida da Cruz",
    role: "Vendedora",
    company: "BRINQPET",
    text: "O curso foi prático, dinâmico e extremamente didático. O professor Junior tem uma forma simples e clara de explicar, e isso fez toda a diferença pra mim. Hoje vejo o mundo das vendas com outros olhos."
  }];
  const etapas = [{
    icon: Search,
    titulo: "1. Diagnóstico comercial",
    prazo: "Semana 1 e 2",
    texto: "Entrevistas com gestor e vendedores, escuta de ligações e reuniões, leitura do CRM e dos números atuais. No fim você recebe um relatório com os gargalos reais da operação — não uma opinião genérica.",
    entrega: "Relatório de diagnóstico com prioridades"
  }, {
    icon: ClipboardList,
    titulo: "2. Desenho do processo",
    prazo: "Semana 3 e 4",
    texto: "Definimos etapas do funil, critérios de passagem, cadência de prospecção, script de abordagem e o playbook que o time vai usar todo dia.",
    entrega: "Playbook e funil desenhados"
  }, {
    icon: Rocket,
    titulo: "3. Treinamento aplicado",
    prazo: "Mês 2",
    texto: "Treinamento in company com simulações do produto e do cliente real da empresa. Cada vendedor treina abordagem, objeção e fechamento até virar comportamento.",
    entrega: "Time treinado e avaliado individualmente"
  }, {
    icon: Repeat,
    titulo: "4. Acompanhamento",
    prazo: "Mês 3 em diante",
    texto: "Reuniões de pipeline, revisão de indicadores e treino contínuo pela plataforma com IA, para o aprendizado não se perder duas semanas depois.",
    entrega: "Ritual comercial rodando sem depender de nós"
  }];
  const faqs = [{
    pergunta: "O que é consultoria comercial?",
    resposta: "Consultoria comercial é o trabalho de diagnosticar a operação de vendas de uma empresa e reconstruir o que está travando o resultado: processo, funil, abordagem, indicadores e rotina de gestão. Diferente de um curso, a consultoria olha a sua realidade específica e acompanha a implantação até virar hábito do time."
  }, {
    pergunta: "Qual a diferença entre consultoria de vendas e treinamento de vendas?",
    resposta: "O treinamento desenvolve a habilidade do vendedor. A consultoria organiza o sistema em volta dele: quem prospecta, quais etapas o negócio percorre, o que é lead qualificado, quais números são acompanhados. Na prática, treinamento sem processo se perde, e processo sem treinamento não sai do papel — por isso trabalhamos os dois juntos."
  }, {
    pergunta: "Quando minha empresa precisa de consultoria comercial?",
    resposta: "Os sinais mais comuns são: a venda depende do dono ou de um vendedor estrela, o faturamento oscila muito de mês para mês, o time não sabe dizer quanto vai fechar, o CRM está desatualizado, vendedor novo demora meses para produzir e o desconto virou o principal argumento de venda."
  }, {
    pergunta: "Quanto custa uma consultoria comercial?",
    resposta: "O investimento varia com o tamanho do time, o número de encontros e o tempo de acompanhamento. Projetos de estruturação normalmente rodam em ciclos de 3 meses, e palestras ou treinamentos pontuais têm valor fechado por evento. O orçamento é montado após uma conversa de diagnóstico gratuita pelo WhatsApp."
  }, {
    pergunta: "Quanto tempo leva para aparecer resultado?",
    resposta: "Ganhos rápidos de abordagem e follow-up aparecem já nas primeiras semanas. Mudança de patamar — previsibilidade de pipeline e conversão maior — costuma se consolidar entre o segundo e o terceiro mês, quando o ritual de gestão já está rodando."
  }, {
    pergunta: "O atendimento é presencial ou online?",
    resposta: "Os dois. O atendimento presencial acontece em Ribeirão Preto e região, São Paulo e outras capitais conforme o projeto. Diagnóstico, mentorias e acompanhamento podem ser feitos online para empresas de todo o Brasil, com o treino contínuo na plataforma com IA."
  }, {
    pergunta: "Serve para qual tamanho de empresa?",
    resposta: "De times de 2 vendedores a estruturas com dezenas de pessoas, em vendas B2B e B2C consultivas. O que muda é a profundidade do projeto: time pequeno foca em processo e abordagem; time grande inclui pré-vendas, gestão de pipeline e formação de líderes."
  }];
  return <div className="min-h-screen bg-background">
    <SEOHead title="Consultoria Comercial e Estruturação de Time de Vendas" description="Consultoria comercial para estruturar seu time de vendas: diagnóstico, processo, treinamento e acompanhamento. Veja como funciona, prazos e quanto custa." keywords="consultoria comercial, consultoria de vendas, estruturação comercial, estruturar time de vendas, treinamento in company, palestrante de vendas" canonicalUrl="https://bianchimbusiness.com.br/consultoria" />

    <Helmet>
      <script type="application/ld+json">{JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Service",
        "serviceType": "Consultoria comercial e treinamento de vendas",
        "name": "Consultoria Comercial e Estruturação de Time de Vendas",
        "url": "https://bianchimbusiness.com.br/consultoria",
        "areaServed": ["Ribeirão Preto", "São Paulo", "Brasil"],
        "provider": {
          "@type": "Organization",
          "name": "Bianchim Business",
          "url": "https://bianchimbusiness.com.br",
          "telephone": "+55 16 98196-0018"
        }
      })}</script>
      <script type="application/ld+json">{JSON.stringify({
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": faqs.map(f => ({
          "@type": "Question",
          "name": f.pergunta,
          "acceptedAnswer": { "@type": "Answer", "text": f.resposta }
        }))
      })}</script>
    </Helmet>

    <Header />

    {/* Hero Section */}
    <section className="py-20 bg-gradient-to-br from-muted/30 via-background to-primary/5" role="banner" aria-label="Introdução aos serviços de consultoria">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-6">
            <h1 className="text-4xl md:text-5xl font-extrabold leading-tight">
              <span className="text-gradient-brand">
                Consultoria Comercial
              </span>
              <br />
              <span className="text-foreground">para Estruturar Seu Time de Vendas</span>
            </h1>
            <p className="text-lg text-muted-foreground leading-relaxed">
              Consultoria de vendas com diagnóstico, processo, treinamento e acompanhamento:
              o caminho para sua equipe comercial vender com método, confiança e previsibilidade.
              Atendimento presencial em Ribeirão Preto e região, e online para todo o Brasil.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Button size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 shadow-glow font-semibold" asChild>
                <a href="https://wa.me/5516981960018?text=Olá! Tenho interesse nos serviços de consultoria." target="_blank" rel="noopener noreferrer" aria-label="Falar com consultor via WhatsApp">
                  Fale com um Consultor
                  <ArrowRight className="ml-2 w-5 h-5" />
                </a>
              </Button>
              <Button size="lg" variant="outline" className="border-primary/50 hover:bg-primary/10" asChild>
                <a href="#servicos" aria-label="Ver todos os serviços disponíveis">
                  Ver Serviços
                </a>
              </Button>
            </div>
          </div>
          <div className="flex justify-center">
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-br from-primary/20 to-accent/20 rounded-2xl blur-xl" aria-hidden="true"></div>
              <img src={juniorBianchim} alt="Junior Bianchim - Consultor e Treinador de Vendas" className="relative w-80 h-auto rounded-2xl shadow-2xl border-2 border-primary/30" />
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* Stats Section */}
    <StatsSection />

    {/* O que é consultoria comercial */}
    <section className="py-20" role="region" aria-label="O que é consultoria comercial">
      <div className="container mx-auto px-4 max-w-4xl">
        <h2 className="text-3xl md:text-4xl font-bold mb-6">
          <span className="text-gradient-brand">O que é consultoria comercial</span>
          <span className="text-foreground"> e quando contratar</span>
        </h2>
        <div className="space-y-5 text-muted-foreground leading-relaxed text-lg">
          <p>
            Consultoria comercial é o trabalho de olhar a sua operação de vendas de dentro para fora e
            reconstruir o que está travando o resultado: o processo, o funil, a abordagem do vendedor,
            os indicadores e a rotina de gestão. Não é palestra motivacional e não é modelo de prateleira —
            é diagnóstico da sua realidade e implantação acompanhada.
          </p>
          <p>
            A pergunta que a maioria dos gestores faz antes de contratar é simples: “meu problema é o time
            ou é o processo?”. Quase sempre é o segundo. Vendedor sem etapa clara, sem critério de lead
            qualificado e sem rotina de treino vira refém do desconto. É por isso que unimos consultoria de
            vendas e treinamento no mesmo projeto: um organiza o sistema, o outro desenvolve quem executa.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-4 mt-10">
          {[
            "A venda depende do dono ou de um único vendedor estrela",
            "O faturamento oscila muito de um mês para o outro",
            "Ninguém consegue dizer com segurança quanto vai fechar no mês",
            "O CRM está desatualizado e o pipeline não é confiável",
            "Vendedor novo demora meses para começar a produzir",
            "Desconto se tornou o principal argumento de venda"
          ].map((sinal, i) => (
            <div key={i} className="flex items-start gap-3 p-4 rounded-xl border border-border bg-card">
              <CheckCircle className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" aria-hidden="true" />
              <span className="text-sm text-foreground/90">{sinal}</span>
            </div>
          ))}
        </div>

        <div className="flex items-center gap-2 mt-8 text-sm text-muted-foreground">
          <MapPin className="w-4 h-4 text-primary" aria-hidden="true" />
          <span>
            Atendimento presencial em Ribeirão Preto, Franca, São Paulo e demais capitais; diagnóstico e
            acompanhamento online para empresas de todo o Brasil.
          </span>
        </div>
      </div>
    </section>

    {/* Como funciona o diagnóstico */}
    <section className="py-20 bg-muted/20" role="region" aria-label="Como funciona o diagnóstico comercial">
      <div className="container mx-auto px-4">
        <div className="text-center mb-14 max-w-2xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            <span className="text-gradient-brand">Como funciona o diagnóstico</span>
          </h2>
          <p className="text-muted-foreground">
            Quatro etapas, do primeiro dia até o time rodando sozinho. Prazos e entregáveis claros desde o começo.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {etapas.map((etapa, i) => (
            <Card key={i} className="p-6 border-border bg-card hover:border-primary/30 transition-all flex flex-col">
              <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center mb-4">
                <etapa.icon className="w-6 h-6 text-primary" aria-hidden="true" />
              </div>
              <span className="text-xs font-semibold text-primary uppercase tracking-wide">{etapa.prazo}</span>
              <h3 className="text-lg font-bold text-foreground mt-2 mb-3">{etapa.titulo}</h3>
              <p className="text-sm text-muted-foreground flex-1">{etapa.texto}</p>
              <p className="text-xs text-foreground/80 mt-4 pt-4 border-t border-border">
                <strong className="text-primary">Entrega:</strong> {etapa.entrega}
              </p>
            </Card>
          ))}
        </div>
      </div>
    </section>

    {/* Services Section */}
    <section id="servicos" className="py-20" role="region" aria-label="Nossos serviços">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4">
            <span className="text-gradient-brand">Nossos Serviços</span>
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Soluções completas para transformar sua operação comercial e gerar resultados reais e sustentáveis.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {servicos.map((servico, index) => <Card key={index} className="p-8 border-border bg-card hover:border-primary/30 transition-all group" role="article" aria-label={servico.title}>
            <div className="mb-4">
              <span className="text-sm font-semibold text-primary">{servico.numero}.</span>
            </div>
            <div className="flex items-start gap-4 mb-4">
              <div className="w-14 h-14 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0 group-hover:bg-primary/20 transition-colors">
                <servico.icon className="w-7 h-7 text-primary" aria-hidden="true" />
              </div>
              <div>
                <h3 className="text-xl font-bold text-foreground mb-2">{servico.title}</h3>
                <p className="text-muted-foreground text-sm">{servico.description}</p>
              </div>
            </div>
            <ul className="space-y-2 mt-4" role="list" aria-label={`Características de ${servico.title}`}>
              {servico.features.map((feature, idx) => <li key={idx} className="flex items-center gap-2 text-sm text-foreground/80">
                <CheckCircle className="w-4 h-4 text-primary flex-shrink-0" aria-hidden="true" />
                {feature}
              </li>)}
            </ul>
          </Card>)}
        </div>
      </div>
    </section>

    {/* Program Section */}
    <section className="py-20 bg-muted/20" role="region" aria-label="Programa de treinamento">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <span className="text-sm font-medium text-primary bg-primary/10 px-4 py-2 rounded-full">
            Programa Mais Contratado
          </span>
          <h2 className="text-4xl font-bold mt-6 mb-4">
            <span className="text-gradient-brand">Vendas Pro 360</span>
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            3 Módulos de Alta Performance para transformar sua equipe comercial
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {programaModulos.map(modulo => <Card key={modulo.numero} className="p-6 border-border bg-card hover:border-primary/30 transition-all" role="article" aria-label={`Módulo ${modulo.numero}`}>
            <div className="w-12 h-12 rounded-full bg-primary text-primary-foreground flex items-center justify-center text-xl font-bold mb-4">
              {modulo.numero}
            </div>
            <h3 className="text-lg font-bold text-foreground mb-4">{modulo.titulo}</h3>
            <ul className="space-y-2" role="list">
              {modulo.topicos.map((topico, idx) => <li key={idx} className="flex items-start gap-2 text-sm text-muted-foreground">
                <CheckCircle className="w-4 h-4 text-primary flex-shrink-0 mt-0.5" aria-hidden="true" />
                {topico}
              </li>)}
            </ul>
          </Card>)}
        </div>

        <div className="text-center mt-12">
          <Button size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 shadow-glow font-semibold" asChild>
            <a href="https://wa.me/5516981960018?text=Olá! Tenho interesse no Treinamento Sucesso em Vendas." target="_blank" rel="noopener noreferrer" aria-label="Solicitar proposta via WhatsApp">
              Solicitar Proposta
              <ArrowRight className="ml-2 w-5 h-5" />
            </a>
          </Button>
        </div>
      </div>
    </section>

    {/* Testimonials Section */}
    <section className="py-20" role="region" aria-label="Depoimentos de clientes">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4">
            <span className="text-gradient-brand">Clientes Satisfeitos</span>
          </h2>
          <p className="text-muted-foreground">O que dizem sobre nossos treinamentos</p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {depoimentos.map((depoimento, index) => <Card key={index} className="p-6 border-border bg-card" role="article" aria-label={`Depoimento de ${depoimento.name}`}>
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-full bg-gradient-to-br from-primary to-accent flex items-center justify-center text-primary-foreground font-bold text-lg flex-shrink-0">
                {depoimento.name.split(' ').map(n => n[0]).join('').slice(0, 2)}
              </div>
              <div>
                <p className="text-muted-foreground text-sm italic mb-4">"{depoimento.text}"</p>
                <p className="font-semibold text-foreground">{depoimento.name}</p>
                <p className="text-sm text-muted-foreground">
                  {depoimento.role}
                  {depoimento.company && ` – ${depoimento.company}`}
                </p>
              </div>
            </div>
          </Card>)}
        </div>
      </div>
    </section>

    {/* Gallery Section - Mentorias */}
    <section className="py-20 bg-muted/20" role="region" aria-label="Galeria de mentorias">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4">
            <span className="text-gradient-brand">Últimas Mentorias</span>
          </h2>
          <p className="text-muted-foreground">Registros dos nossos treinamentos e eventos</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {[mentoria1, mentoria2, mentoria3, mentoria4, mentoria5, mentoria6].map((img, index) => <div key={index} className="aspect-square rounded-xl overflow-hidden group cursor-pointer" role="img" aria-label={`Foto de mentoria ${index + 1}`}>
            <img src={img} alt={`Treinamento e mentoria ${index + 1}`} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" loading="lazy" />
          </div>)}
        </div>
      </div>
    </section>

    {/* FAQ Section */}
    <section className="py-20" role="region" aria-label="Perguntas frequentes sobre consultoria comercial">
      <div className="container mx-auto px-4 max-w-4xl">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            <span className="text-gradient-brand">Perguntas frequentes</span>
          </h2>
          <p className="text-muted-foreground">
            O que os gestores mais perguntam antes de contratar uma consultoria de vendas
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, i) => (
            <Card key={i} className="p-6 border-border bg-card">
              <div className="flex items-start gap-3">
                <HelpCircle className="w-5 h-5 text-primary flex-shrink-0 mt-1" aria-hidden="true" />
                <div>
                  <h3 className="text-lg font-bold text-foreground mb-2">{faq.pergunta}</h3>
                  <p className="text-muted-foreground leading-relaxed">{faq.resposta}</p>
                </div>
              </div>
            </Card>
          ))}
        </div>

        <p className="text-center text-muted-foreground mt-10">
          Quer ir mais fundo antes de falar com a gente? Leia o{" "}
          <Link to="/posts/treinamento-de-vendas" className="text-primary hover:underline font-medium">
            guia de treinamento de vendas
          </Link>{" "}
          e o passo a passo de{" "}
          <Link to="/posts/como-montar-equipe-de-vendas-do-zero" className="text-primary hover:underline font-medium">
            como montar uma equipe de vendas do zero
          </Link>.
        </p>
      </div>
    </section>

    {/* CTA Section */}
    <section className="py-20" role="region" aria-label="Chamada para ação">
      <div className="container mx-auto px-4">
        <Card className="p-12 bg-gradient-to-br from-card via-primary/5 to-accent/10 border-primary/30 text-center relative overflow-hidden">
          <div className="relative z-10">
            <h2 className="text-4xl md:text-5xl font-bold mb-4">
              <span className="text-gradient-brand">
                Pronto para Transformar Suas Vendas?
              </span>
            </h2>
            <p className="text-xl text-muted-foreground max-w-2xl mx-auto mb-8">
              Entre em contato conosco e descubra como podemos ajudar sua equipe a alcançar resultados extraordinários.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 shadow-glow text-lg px-8 py-6 font-semibold" asChild>
                <a href="https://wa.me/5516981960018?text=Olá! Gostaria de saber mais sobre os serviços de consultoria." target="_blank" rel="noopener noreferrer" aria-label="Fale conosco via WhatsApp">
                  <MessageSquare className="mr-2 w-5 h-5" />
                  Fale Conosco
                </a>
              </Button>
              <Button size="lg" variant="outline" className="text-lg px-8 py-6 border-primary/50 hover:bg-primary/10" asChild>
                <a href="https://wa.me/5516981960018?text=Olá! Gostaria de agendar uma reunião para discutir consultoria." target="_blank" rel="noopener noreferrer" aria-label="Agendar reunião via WhatsApp">
                  <Calendar className="mr-2 w-5 h-5" />
                  Agendar Reunião
                </a>
              </Button>
            </div>
          </div>
        </Card>
      </div>
    </section>

    {/* Also check the platform */}
    <section className="py-12 border-t border-border" role="region" aria-label="Conheça a plataforma">
      <div className="container mx-auto px-4 text-center">
        <p className="text-muted-foreground mb-4">
          Além da consultoria presencial, conheça nossa plataforma de treinamento com IA
        </p>
        <Button variant="outline" className="border-primary/50 hover:bg-primary/10" asChild>
          <Link to="/" aria-label="Conhecer a plataforma Vendas Trainer">
            Conhecer Vendas Trainer
            <ArrowRight className="ml-2 w-4 h-4" />
          </Link>
        </Button>
      </div>
    </section>

    <Footer />
  </div>;
};
export default Consultoria;
